import React, { PureComponent } from 'react';

export interface LabelProps {
  text: number | string;
  width: number;
  fontName?: string;
  fontSize?: number;
  align?: string;
  padding?: number;
  foregroundColor?: string;
  foregroundColorOpacity?: number;
  fontStyle?: string;
}

export default class Label extends PureComponent<LabelProps> {
  render() {
    const adjustedWidth = this.props.padding ? this.props.width - this.props.padding * 2 : this.props.width;
    const adjustedX = this.props.width / 2 - adjustedWidth / 2;

    let dx;
    let textAnchor = 'start';
    const fieldAlign = this.props.align ? this.props.align.toLowerCase() : 'left';
    switch (fieldAlign) {
      case 'center':
        dx = adjustedWidth / 2.0;
        textAnchor = 'middle';
        break;
      case 'right':
        dx = adjustedWidth;
        textAnchor = 'end';
        break;
      case 'left':
      default:
        dx = adjustedX;
        textAnchor = 'start';
        break;
    }

    const style = {
      fontFamily: this.props.fontName,
      fontSize: this.props.fontSize === null || this.props.fontSize === undefined ? 16 : this.props.fontSize,
      fontStyle: this.props.fontStyle
    };

    const dy = style.fontSize * 0.35;
    return (
      <svg>
        <text
          dx={dx}
          dy={dy}
          y="50%"
          style={style}
          textAnchor={textAnchor}
          fill={this.props.foregroundColor || 'black'}
          fillOpacity={this.props.foregroundColorOpacity}
          data-testid="label-text"
        >
          {this.props.text}
        </text>
      </svg>
    );
  }
}
